module.exports = __webpack_public_path__ + "img/tatiana.4aee1500.png";